import { FC } from 'react';

import { HelpText, HelpChapterProps, useConfigSlice } from '@pp/core';

export const HelpChapterReturnToPlayer: FC<HelpChapterProps> = ({ content }) => {
  const rtp = useConfigSlice.getRtp();
  const optimalRtp = rtp ? rtp.optimalRTP : undefined;
  const optimalRtpMin = rtp ? (rtp['optimalRTP-min'] as string) : undefined;
  const optimalRtpMax = rtp ? (rtp['optimalRTP-max'] as string) : undefined;

  if (!content) return null;

  return (
    <div>
      <p>
        <HelpText
          dynamicValues={{
            optimalRTP: `${optimalRtp}%`,
            optimalRTP_min: `${optimalRtpMin}%`,
            optimalRTP_max: `${optimalRtpMax}%`,
          }}
        >
          {String(content.payout)}
        </HelpText>
      </p>
    </div>
  );
};
